import {Controller, useFormContext} from "react-hook-form";
import {GroupBase, SelectComponentsConfig, StylesConfig} from "react-select";
import classNames from "classnames";

import {FieldWrapper, InputWrapper} from "@pg-design/inputs-module";
import {type ISelectAsyncProps, SelectAsync} from "@pg-design/select-module";

import {selectStyle} from "./SelectField.module.css";

export interface SelectAsyncFieldControlledProps<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>
    extends Pick<
        ISelectAsyncProps<Option, IsMulti, Group>,
        | "loadOptions"
        | "isMulti"
        | "options"
        | "placeholder"
        | "isSearchable"
        | "isBorderless"
        | "menuPosition"
        | "isClearable"
        | "onFocus"
        | "onBlur"
        | "loadingMessage"
        | "noOptionsMessage"
        | "styles"
        | "cacheOptions"
        | "closeMenuOnSelect"
        | "defaultOptions"
    > {
    components?: SelectComponentsConfig<Option, IsMulti, Group>;
    label?: string;
    name: string;
    wrapperClassName?: string;
    className?: string;
    required?: boolean;
    noOptionsText?: string;
    dataTestId?: string;
}

export const SelectAsyncFieldControlled = <Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(
    props: SelectAsyncFieldControlledProps<Option, IsMulti, Group>
) => {
    const {control, setValue, formState} = useFormContext();
    const selectCN = classNames(props.className, selectStyle);
    const components = props.components as SelectComponentsConfig<unknown, boolean, GroupBase<unknown>>;
    const styles = props.styles as StylesConfig<unknown, boolean, GroupBase<unknown>> | undefined;

    return (
        <Controller
            control={control}
            name={props.name}
            render={({field, fieldState}) => {
                const error: string | undefined = fieldState.error?.message;
                return (
                    <FieldWrapper
                        fieldState={!!error ? "error" : "default"}
                        labelContent={props.label}
                        message={error}
                        required={props.required}
                        className={props.wrapperClassName}
                        dataTestId={props.dataTestId}
                    >
                        <InputWrapper fieldState={!!error ? "error" : "default"} noPadding>
                            <SelectAsync
                                noOptionsText={props.noOptionsText}
                                noOptionsMessage={props.noOptionsMessage}
                                isClearable={props.isClearable}
                                isMulti={props.isMulti}
                                placeholder={props.placeholder}
                                isBorderless // border handling moved to InputWraper for easier fieldState handling
                                isSearchable={props.isSearchable}
                                isDisabled={formState.disabled}
                                components={components}
                                menuPosition={props.menuPosition}
                                value={field.value}
                                onChange={(newValue) => {
                                    setValue(props.name, newValue);
                                }}
                                onFocus={props.onFocus}
                                onBlur={props.onBlur}
                                loadingMessage={props.loadingMessage}
                                styles={styles}
                                className={selectCN}
                                loadOptions={props.loadOptions}
                                cacheOptions={props.cacheOptions}
                                closeMenuOnSelect={props.closeMenuOnSelect}
                                defaultOptions={props.defaultOptions}
                            />
                        </InputWrapper>
                    </FieldWrapper>
                );
            }}
        />
    );
};
import {Controller, useFormContext} from "react-hook-form";
import {GroupBase, SelectComponentsConfig, StylesConfig} from "react-select";
import classNames from "classnames";

import {FieldWrapper, InputWrapper} from "@pg-design/inputs-module";
import {type ISelectAsyncProps, SelectAsync} from "@pg-design/select-module";

import {selectStyle} from "./SelectField.module.css";

export interface SelectAsyncFieldControlledProps<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>
    extends Pick<
        ISelectAsyncProps<Option, IsMulti, Group>,
        | "loadOptions"
        | "isMulti"
        | "options"
        | "placeholder"
        | "isSearchable"
        | "isBorderless"
        | "menuPosition"
        | "isClearable"
        | "onFocus"
        | "onBlur"
        | "loadingMessage"
        | "noOptionsMessage"
        | "styles"
        | "cacheOptions"
        | "closeMenuOnSelect"
        | "defaultOptions"
    > {
    components?: SelectComponentsConfig<Option, IsMulti, Group>;
    label?: string;
    name: string;
    wrapperClassName?: string;
    className?: string;
    required?: boolean;
    noOptionsText?: string;
    dataTestId?: string;
}

export const SelectAsyncFieldControlled = <Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(
    props: SelectAsyncFieldControlledProps<Option, IsMulti, Group>
) => {
    const {control, setValue, formState} = useFormContext();
    const selectCN = classNames(props.className, selectStyle);
    const components = props.components as SelectComponentsConfig<unknown, boolean, GroupBase<unknown>>;
    const styles = props.styles as StylesConfig<unknown, boolean, GroupBase<unknown>> | undefined;

    return (
        <Controller
            control={control}
            name={props.name}
            render={({field, fieldState}) => {
                const error: string | undefined = fieldState.error?.message;
                return (
                    <FieldWrapper
                        fieldState={!!error ? "error" : "default"}
                        labelContent={props.label}
                        message={error}
                        required={props.required}
                        className={props.wrapperClassName}
                        dataTestId={props.dataTestId}
                    >
                        <InputWrapper fieldState={!!error ? "error" : "default"} noPadding>
                            <SelectAsync
                                noOptionsText={props.noOptionsText}
                                noOptionsMessage={props.noOptionsMessage}
                                isClearable={props.isClearable}
                                isMulti={props.isMulti}
                                placeholder={props.placeholder}
                                isBorderless // border handling moved to InputWraper for easier fieldState handling
                                isSearchable={props.isSearchable}
                                isDisabled={formState.disabled}
                                components={components}
                                menuPosition={props.menuPosition}
                                value={field.value}
                                onChange={(newValue) => {
                                    setValue(props.name, newValue);
                                }}
                                onFocus={props.onFocus}
                                onBlur={props.onBlur}
                                loadingMessage={props.loadingMessage}
                                styles={styles}
                                className={selectCN}
                                loadOptions={props.loadOptions}
                                cacheOptions={props.cacheOptions}
                                closeMenuOnSelect={props.closeMenuOnSelect}
                                defaultOptions={props.defaultOptions}
                            />
                        </InputWrapper>
                    </FieldWrapper>
                );
            }}
        />
    );
};
